import { lazy } from "react"

const PrepareSpinPage$$__react__lazy__component = lazy(() => 
    import("./PrepareSpinPage__original__module.mjs")
        .then(module => module.get_$$PrepareSpinPage$$PrepareSpinPage$$react__component$$2vcabxyvclzxd())
        .then(component => ({ default: component }))
)

export const get_$$PrepareSpinPage$$PrepareSpinPage$$react__component$$2vcabxyvclzxd = () => PrepareSpinPage$$__react__lazy__component